import {
  Avatar,
  Card,
  CardHeader,
  CardBody,
  Divider,
  Link,
  Modal,
  ModalBody,
  ModalContent,
} from '@heroui/react';
import _ from 'lodash';
import React, { useState } from 'react';
import { parse } from 'node-html-parser';

import { replaceHeaders } from '@/patient-app-common/helpers/education_helpers';
import useSegment from '@/hooks/useSegment';

const EDUCATION_EVENT = 'Education Topic Viewed';

export function ResultCard({ recommendation }) {
  const { sendTrackEvent } = useSegment();

  const [modal, toggleModal] = useState(false);
  const [eduHTML, setEduHTML] = useState('');

  const createEduModal = (ruleHTML) => {
    if (!ruleHTML) {
      return <div />;
    }

    const root = parse(ruleHTML);
    const linkElements = root.querySelectorAll(
      'a[href*="seamless.md/#/education/"]'
    );
    linkElements.forEach((element) => {
      element.removeAttribute('target');
    });
    let formattedHTML = root.toString();

    const H1 = root.querySelector('h1');

    if (H1) {
      H1.remove();

      const header = `<h1><strong>${H1.innerHTML}</strong></h1>`;

      formattedHTML = header + replaceHeaders(root.toString());
      formattedHTML = `<div class="ed-v3">${formattedHTML}</div>`;
    }

    const fragment = (
      <div dangerouslySetInnerHTML={{ __html: formattedHTML }} />
    );

    return setEduHTML(fragment);
  };

  const icon = `/icons/${recommendation.apptext.recIconImage}`;
  const color = recommendation.apptext.recRecommendationBackgroundColor;

  const openEdu = (ruleEdu) => {
    const { ids, titles, html } = ruleEdu;
    createEduModal(html);

    if (ids.length) {
      ids.forEach((id, index) =>
        sendTrackEvent(EDUCATION_EVENT, {
          id,
          title: titles[index],
          source: 'ResultCard',
        })
      );
    }

    toggleModal(true);
  };

  const getMessageList = () =>
    recommendation.messageList.map((item) => {
      if (_.isEmpty(item)) {
        return null;
      }

      return (
        <>
          <li key={item.ruleMsg}>{item.ruleMsg}</li>
          {!_.isEmpty(item.ruleEdu.html) && (
            <Link
              className="text-sm"
              onPress={() => openEdu(item.ruleEdu)}
              href="#"
            >
              {item.ruleEduLink}
            </Link>
          )}
        </>
      );
    });

  return (
    <>
      <Modal
        isOpen={modal}
        onClose={() => toggleModal(false)}
        scrollBehavior="inside"
        size="5xl"
      >
        <ModalContent>
          <ModalBody>{eduHTML}</ModalBody>
        </ModalContent>
      </Modal>
      <Card shadow="sm">
        <CardHeader className="gap-4">
          <Avatar size="md" src={icon} style={{ backgroundColor: color }} />
          <h3 className="font-semibold text-lg">
            {recommendation.apptext.recLabelText}
          </h3>
        </CardHeader>
        <Divider />
        <CardBody className="pl-8 space-y-4 whitespace-pre-line">
          <p className="text-sm">{recommendation.apptext.recListText}</p>
          <ul className="list-disc pl-8 space-y-4 text-sm">
            {getMessageList()}
          </ul>
          <p className="text-sm">{recommendation.apptext.recDetailsText}</p>
        </CardBody>
      </Card>
    </>
  );
}
